<template>
	<div class="vue-wrapper">
	<lane-closure-request-quick-nav v-if="!$store.state.isMobile" v-model="laneClosureRequest" selected="attachments"></lane-closure-request-quick-nav>
	<lane-closure-request-quick-nav-mobile v-if="$store.state.isMobile" v-model="laneClosureRequest" selected="attachments"></lane-closure-request-quick-nav-mobile>
	<b-container class="laneclosure-view-container" v-if="loaded">
		<b-form>
			<b-row v-if="$store.state.isMobile">
				<b-col class="pt-0 lcr-quick-nav-summary lcr-quick-nav-summary-mobile" sm="12" xl="9">
					<div class="lcr-page-title">
						<div>
							<h1>Violations</h1>
						</div>
					</div>
				</b-col>
			</b-row>
			<b-row :class="$store.state.isMobile ? 'lcr-detail-mobile-wrapper' : ''">
				<b-col v-if="!$store.state.isMobile" class="lcr-quick-nav-summary" sm="12" lg="9">
					<b-row v-if="laneClosureRequest.isEmergency.value == 1">
						<b-col class="pt-0">
							<h1>Violations</h1>
						</b-col>
					</b-row>
					<b-row v-if="laneClosureRequest.isEmergency.value == 0">
						<b-col>
							<h1>Violations</h1>
						</b-col>
					</b-row>
					<b-row v-if="laneClosureRequest.requesterProjectName">
						<b-col class="pt-1">
							<h2>Project: {{laneClosureRequest.requesterProjectName}}</h2>
						</b-col>
					</b-row>

					<lane-closure-view-info v-model="laneClosureRequest"></lane-closure-view-info>
					<!-- <div class="d-flex lcr-main-summary">
						<div class="lcr-main-summary__info">
							<div class="lcr-summary__label">Info</div>
							<div class="lcr-summary__value" v-show="laneClosureRequest.trafficManagementRef.value">TM: {{laneClosureRequest.trafficManagementRef.value}}</div>
							<div class="lcr-summary__value">LCR: {{laneClosureRequest.id}}</div>
						</div>
						<div class="lcr-main-summary__info flex-grow-1">
							<div class="lcr-summary__label">Affected Streets</div>
							<div class="lcr-summary__value">{{directionOfTravel}}</div>
							<div class="lcr-summary__value">{{laneClosureRequest.affectedStreet.value}}</div>
							<div class="lcr-summary__value">{{laneClosureRequest.firstCrossStreet.value}} to {{laneClosureRequest.lastCrossStreet.value}}</div>
						</div>
						<div class="lcr-main-summary__info pt-4">
							<div class="show-on-map-wrapper">
								<a class="show-on-map text-left" @click="showOnMap">
									<span v-if="hideMap" class="on-container">
										<img class="on-badge responsive-img" src="@/assets/map-badge-hide.svg" alt="on-badge" />
										<img class="on-map responsive-img" src="@/assets/hide-map.svg" alt="on-map" />
									</span>
									<span v-else class="on-container">
										<img class="on-badge responsive-img" src="@/assets/map-badge.svg" alt="on-badge" />
										<img class="on-map responsive-img" src="@/assets/show-on-map.svg" alt="on-map" />
									</span>
								</a>
							</div>
						</div>
						<div class="lcr-main-summary__info">
							<div class="lcr-summary__label">Primary Reason for Closure</div>
							<div class="lcr-summary__value">{{natureOfWork}}</div>
						</div>
						<div class="lcr-main-summary__info ">
							<div class="lcr-summary__label">Date(s)</div>
							<div class="lcr-summary__value">{{moment(laneClosureRequest.fromDate.value).format('MM/DD/YYYY')}} - {{moment(laneClosureRequest.toDate.value).format('MM/DD/YYYY')}}</div>
							<div class="lcr-summary__value">{{moment(laneClosureRequest.fromDate.value).format('H:mm')}} - {{moment(laneClosureRequest.toDate.value).format('H:mm')}}</div>
						</div>
						<div class="lcr-main-summary__info" v-if="laneClosureRequest.completeTypeId.value != null">
							<div class="lcr-summary__label">Complete Status</div>
							<div class="lcr-summary__value">{{LaneClosureRequest.getCompleteTypeIdText(laneClosureRequest.completeTypeId.value)}}</div>
						</div>
						<div class="lcr-main-summary__info">
							<div class="lcr-summary__label">Approval Status</div>
							<div class="lcr-summary__value">{{LaneClosureRequest.getApprovalStatusIdText(laneClosureRequest.approvalStatusId.value)}}</div>
							<div class="lcr-summary__label">Record Status</div>
							<div class="lcr-summary__value">{{LaneClosureRequest.getRecordStatusText(laneClosureRequest.recordStatusId.value)}}</div>
						</div>
					</div> -->
				</b-col>
				<b-col v-if="$store.state.isMobile" class="lcr-quick-nav-summary lcr-quick-nav-summary-mobile" sm="12" lg="9">
					<lane-closure-view-info v-model="laneClosureRequest"></lane-closure-view-info>
				</b-col>
				<b-col lg="3" class="lcr-main-actions hide-mobile">
					<b-row v-show="canReportContravention">
						<b-col class="">
							<b-button block variant="primary" @click="onReportContravention" class="mr-2 mb-2 text-uppercase">Report New Violation</b-button>
						</b-col>
					</b-row>
				</b-col>
			</b-row>
			<b-row v-if="laneClosureRequest.contravention.length == 0">
				<b-col class="pt-3 pr-lg-0" lg="9">
					<b-alert variant="success" class="mr-0" show>No contraventions or infractions entered for this request.</b-alert>
				</b-col>
			</b-row>
			<lane-closure-request-contravention-list :showEditButton="canReportContravention"  v-model="laneClosureRequest.contravention" :downloadToken="downloadToken" :downloadTokenExpires="downloadTokenExpires"  :key="`lcr-contravention-list`+renderCounter"></lane-closure-request-contravention-list>


			<h1 class="page-title pt-2">Lane Closure Request Information</h1>
			<div class="comments__traffic">
				<b-row style="border-bottom: #C3C5DA 1px solid">
					<b-col lg="9" class="mb-2 pt-2">
						<div class="lcr-summary__section-label">Comments and Explanations</div>
						<div class="lcr-summary__section-value" v-if="laneClosureRequest.requesterComments.value" v-html="laneClosureRequest.requesterComments.value"></div>
						<div class="lcr-summary__section-value" v-else>N/A</div>
					</b-col>
				</b-row>
				<b-row>
					<b-col lg="9">
						<div class="lcr-summary__section-label">Traffic Effect for the Public</div>
						<div v-if="laneClosureRequest.trafficEffect.value" class="lcr-summary__section-value" v-html="laneClosureRequest.trafficEffect.value"></div>
					</b-col>
				</b-row>
			</div>

		</b-form>

</b-container>
<Spinner v-else />
</div>
</template>


<script>
// import CloneDeep from 'lodash.clonedeep';
import LaneClosureRequest from '../../models/LaneClosureRequest';
import LaneClosureRequestBlock from '../../models/LaneClosureRequestBlock';
import Contravention from '../../models/Contravention';

// import Datepicker from 'vuejs-datepicker';
import ErrorHandler from '../../utility/ErrorHandler';
import KMLHelper from '../../utility/KMLHelper';
import Format from '../../utility/Format';

import LaneClosureViewInfo from '../../components/LaneClosureViewInfo.vue';
import LaneClosureRequestQuickNav from '../../components/LaneClosureRequestQuickNav.vue';
import LaneClosureRequestQuickNavMobile from '../../components/LaneClosureRequestQuickNavMobile.vue';
import LaneClosureRequestContraventionList from '../../components/LaneClosureRequestContraventionList';
import Vue from 'vue'

import Spinner from "./../../components/Spinner.vue"


export default {
	name: 'LaneClosureRequestContraventions',
	docTitle() {
		return `Request ${this.id} Violations - Lane Closures`;
	},

	components: {
		LaneClosureRequestQuickNav,
		LaneClosureViewInfo,
		LaneClosureRequestQuickNavMobile,
		'lane-closure-request-contravention-list':LaneClosureRequestContraventionList,
		Spinner,
	},
	props: ['id'],
	data() {
		return {
			LaneClosureRequest,
			Contravention,
			downloadToken:null,
			downloadTokenExpires:null,
		laneClosureRequest: null,
		loaded:null,
		hideMap: false,
		renderCounter: 0,
	}
},
mounted() {
		this.LoadLaneClosureRequest();
		this.setEventBusOn();
		this.$nextTick(() => {
		})

		this.hideMap = Vue.prototype.$mapShown;
		this.$bus.$off('map:shown', this.changeToHideMap);
		this.$bus.$off('map:hidden', this.changeToShowMap);
		this.$bus.$on('map:shown', this.changeToHideMap);
		this.$bus.$on('map:hidden', this.changeToShowMap);
	},
	computed: {
		canReportContravention() {
			if (this.laneClosureRequest) {
				return this.$store.getters.userCanReportContravention();
			}
			return false;
		},
		directionOfTravel() {
			if (this.laneClosureRequest.directionId.value) {
				return Format.searchById(this.laneClosureRequest.directionId.value, LaneClosureRequest.getDirectionIdOptions).name;
			}
			return null;
		},
		getPeakIdText() {
			if (this.laneClosureRequest.peakId.value) {
				return Format.searchById(this.laneClosureRequest.peakId.value, LaneClosureRequest.getClosurePeakReason).name;
			}
			return null;
		},

		natureOfWork() {
			if (this.laneClosureRequest.natureOfWorkId.value) {
				return Format.searchById(this.laneClosureRequest.natureOfWorkId.value, LaneClosureRequest.getNatureOfWorkOptions).name;
			}
			return null;
		},
	},

	watch: {
		'$route.params': function() {
		},
	},

	beforeDestroy() {
		this.setEventBusOff();
	},
	methods: {
		forceRerender() {
			this.renderCounter += 1;
		},

		setEventBusOff() {
			this.$bus.$off('lane-closure-request:view-contravention', this.viewContravention);
			this.$bus.$off('lane-closure-request:edit-contravention', this.editContravention);
			this.$bus.$off('lane-closure-request:expand-contravention', this.onToggleExpandContravention);

		},
		setEventBusOn() {
			this.setEventBusOff();
			this.$bus.$on('lane-closure-request:view-contravention', this.viewContravention);
			this.$bus.$on('lane-closure-request:edit-contravention', this.editContravention);
			this.$bus.$on('lane-closure-request:expand-contravention', this.onToggleExpandContravention);

		},
		onReportContravention() {
			if(this.laneClosureRequest.id) {
				this.$router.push({name:"ReportContravention", params:{id:this.laneClosureRequest.id}});
			}
		},
		editContravention(obj) {
			if(this.laneClosureRequest.id) {
				this.$router.push({name:"EditContravention", params:{id:this.laneClosureRequest.id, contraventionId:obj.id}});
			}
		},
		viewContravention(obj) {
			if(this.laneClosureRequest.id) {
				this.$router.push({name:"ViewContravention", params:{id:this.laneClosureRequest.id, contraventionId:obj.id}});
			}
		},
		setBlockPolyline(block) {
			let that = this;
			let foundIndex = null;
			let blockPolyline = null;
			if (block) {
				// find the existing marker/placemark.
				if (this.laneClosureRequest.block) {
					for (var x = 0; x < this.laneClosureRequest.block.length; x++) {
						if (this.laneClosureRequest.block[x].blockId == block.blockId) {
							foundIndex = x;
							if (that.$store.getters["map/polylines"]) {
								for (x =0; x < that.$store.getters["map/polylines"].length; x++) {
									if (that.$store.getters["map/polylines"][x]) {
									if (that.$store.getters["map/polylines"][x].blockData.blockId == block.blockId) {
										blockPolyline = that.$store.getters["map/polylines"][x];
									}
								}
								}
							}
						}
					}
				}
				if (foundIndex == null || blockPolyline == null) {
					// add the block to the map.
					// look for existing block in lane closure request, and select it.
					var myParser = new Vue.prototype.$geoXML3.parser({map:null, afterParse: function(doc) {
						let xx = 0;
						var coords = [];
						let zz = 0;
						for (xx = 0; xx < doc[0].gpolylines[0].latLngs.length; xx++) {
							for (zz = 0; zz < doc[0].gpolylines[0].latLngs.getAt(xx).length; zz++) {
								coords.push(new google.maps.LatLng(doc[0].gpolylines[0].latLngs.getAt(xx).getAt(zz).lat(), doc[0].gpolylines[0].latLngs.getAt(xx).getAt(zz).lng()));
							}
						}
					let mapPolyline = new google.maps.Polyline({
							map: that.$store.state.map.map,
							path: coords,
							strokeColor: '#666666',
							strokeOpacity: 1.0,
							strokeWeight: 8
							});
					mapPolyline.blockData = block;
					let mapIndex = -1;
					if (foundIndex == null) {
						let newBlock = new LaneClosureRequestBlock(block);
							that.laneClosureRequest.block.push(newBlock);
							foundIndex = that.laneClosureRequest.block.length - 1;
							}
							if (that.$store.getters["map/polylines"]) {
								for (x =0; x < that.$store.getters["map/polylines"].length; x++) {
									if (that.$store.getters["map/polylines"][x]) {
									if (that.$store.getters["map/polylines"][x].blockData.blockId == block.blockId) {
										that.$store.commit("map/setPolylineByIndex", x, mapPolyline);
										mapIndex = x;
									}
									}
								}
							}
					if (mapIndex == -1) {
						// not found, so add the polyline.
						that.$store.commit("map/addPolyline", mapPolyline);
					}
					google.maps.event.addListener(mapPolyline, 'click', function() {
						that.$bus.$emit('view-lcr:map:block-edit', this.blockData.blockId);
						});
						return;
					}
					});
					let kmlString = "";
					if (block.kml != "") {
						let color = "7fff0000";
						if (block.streetName != that.laneClosureRequest.affectedStreet.value) {
							// turning restriction
							color = "7f000000"
						}
						kmlString += KMLHelper.createPlaceMarkFromGeometry(block.blockId, block.streetName, block.fromStreet, block.toStreet, block.kml, color, "8");
						kmlString = KMLHelper.finalizeKml(kmlString);
						myParser.parseKmlString(kmlString);
					}
				}
			}
		},


		showOnMap() {
			Vue.prototype.$bus.$emit("map:toggle", null, this.hideMap ? 0 : 1);
			this.$nextTick(() => {
				this.$store.dispatch("map/zoomToLaneClosureRequestId", this.laneClosureRequest.id);
				this.setAllPolylineColours();
			});
		},

		setAllPolylineColours() {
			let x = 0;
			for (x = 0; x < this.$store.getters["map/polylines"].length; x++) {
				if (this.$store.getters["map/polylines"][x]) {
					if (this.$store.getters["map/polylines"][x].blockData) {
						this.$store.getters["map/polylines"][x].setOptions({ strokeColor: '#293C7C' });
					}
				}
			}
		},
		zoomAllBlocks() {
			this.$store.dispatch("map/zoomAllBlocks", null);
		},

		onToggleExpandContravention(value) {
			if (this.laneClosureRequest.contravention[value.index]) {
				this.laneClosureRequest.contravention[value.index].expand = value.expand;
				this.forceRerender();
			}
		},


		LoadLaneClosureRequest(id = this.id) {
				this.loaded = false;
					// Remove any messages being displayed.
					this.submissionStatus = null;

					if (id && Format.TryParseInt(id) > 0) {
						this.GetLaneClosureRequest(id);
					}
					else {
						if (this.data) {
							this.laneClosureRequest = new LaneClosureRequest(this.data);
							this.laneClosureRequest.saveChanges();
							this.$store.commit('laneClosureRequest/setData', this.laneClosureRequest);

						} else {
							this.laneClosureRequest = new LaneClosureRequest();
							// {useTestData:true}
						}
						this.loaded = true;
					}
				},
				// Loads lane closure request into the component based on provided id.
				GetLaneClosureRequest(id) {
					if (Format.TryParseInt(id)) {
						this.loaded = false;
						Vue.prototype.$http({
							method: 'get',
							url: `${this.$store.state.apiUrl}/lane-closure-request/${id}/view?r=${Math.round(Math.random() * Math.pow(10, 6))}`
						}).then(response => {
							this.laneClosureRequest = new LaneClosureRequest(response.data.request);
							this.downloadToken = response.data.downloadToken;
							this.downloadTokenExpires = response.data.downloadTokenExpires;

							this.loaded = true;
							if (this.laneClosureRequest.block) {
								let x = 0;
								for (x = 0; x < this.laneClosureRequest.block.length; x++) {
									this.setBlockPolyline(this.laneClosureRequest.block[x]);
								}
								this.zoomAllBlocks();
							}
							if (this.$store.getters.userHasRole('internal_admin_requests')) {
								if (this.laneClosureRequest.recordStatusId.value == 2) {	// New, automatically set it to Under Review
									this.laneClosureRequest.recordStatusId.value = 3;
									this.postSetStatus(false);
								}
							}



						}).catch(error => {
							if (!ErrorHandler.HasLoginErrorCode(error)) {
								if (error.response && error.response.data) {
									this.loaded = false;
									this.transactionStatus = 'load-error';
									this.errorDetails = error.response.data;
								}
								else {
									console.error(error);
								}
							} else {
								// ErrorHandler.RedirectToLogin();
							}
						});
					}
				},

				changeToHideMap(x) {
					this.hideMap = true;
				},
				changeToShowMap(x) {
					this.hideMap = false;
				},
	},
}
</script>
<i18n>
{
	"en-CA": {

	}
}

</i18n>